import ga from "@toolkit/Framework/Common/GoogleAnalytics";

const getDiscount = (listPrice: number, netPrice: number) => {
    const discount = ga.util.parseAmount(listPrice - netPrice) || 0;

    return discount <= 0 ? undefined : discount;
};

export default getDiscount;
